























































































import Vue from 'vue';

import { animate } from '@/utils/animations';
import { BASIC_COLORS, DEFAULT_COLORS, DEFAULT_SHADES } from '@/utils/tailwind-colors';
import Obj from '@/utils/Obj';

import AppFooter from '@/components/AppFooter.vue';
import ColorShadesEditor from '@/components/ColorShadesEditor.vue';
import ExportButton from '@/components/ExportButton.vue';
import ImportButton from '@/components/ImportButton.vue';
import RemoveButton from '@/components/RemoveButton.vue';

interface Data {
    activeColor: number | null;
    colors: ColorDefinition[];
}

export default Vue.extend({
    components: {
        AppFooter,
        ColorShadesEditor,
        ExportButton,
        ImportButton,
        RemoveButton,
    },
    data: (): Data => ({
        activeColor: 0,
        colors: Obj.deepClone(BASIC_COLORS),
    }),
    methods: {
        updateColors(colors: ColorDefinition[]): void {
            this.colors = colors;
        },
        loadDefaults() {
            this.colors = Obj.deepClone(DEFAULT_COLORS);
        },
        addColor() {
            this.colors.push({
                name: 'new-color',
                shades: Obj.deepClone(DEFAULT_SHADES),
            });

            this.activeColor = this.colors.length - 1;
        },
        removeColor(index: number) {
            this.colors.splice(index, 1);

            if (this.activeColor === null)
                return;

            if (this.activeColor >= index)
                this.activeColor = index > 0 ? this.activeColor - 1 : null;
        },
        toggleColor(index: number) {
            if (this.activeColor === index) {
                this.activeColor = null;

                return;
            }

            this.activeColor = index;

            const scroll = this.$refs.scroll as HTMLDivElement;
            const exportButton = (this.$refs['export-button'] as Vue).$el as HTMLButtonElement;
            const scrollStart = scroll.scrollTop;
            const scrollEnd = exportButton.offsetTop + exportButton.clientHeight;

            animate(progress => {
                scroll.scrollTo({ top: scrollStart * (1 - progress) + scrollEnd * progress });
            }, 300);
        },
    },
});
